import { render, staticRenderFns } from "./ChatSeparator.vue?vue&type=template&id=e3f9a1d6&scoped=true&lang=pug&"
import script from "./ChatSeparator.vue?vue&type=script&lang=js&"
export * from "./ChatSeparator.vue?vue&type=script&lang=js&"
import style0 from "./ChatSeparator.vue?vue&type=style&index=0&id=e3f9a1d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f9a1d6",
  null
  
)

export default component.exports